import { get, jsonParser } from './Client';

export const loadEnum = (className) => get('/options/' + className).then(jsonParser);



// WEBPACK FOOTER //
// ./src/utils/Enums.js